import { createI18n } from "vue-i18n";
import { messages } from "./lang";

// サポートしている言語のリスト
const supportedLocales = ["ja", "en"];

// ブラウザの言語を検出する関数
function detectBrowserLanguage() {
  // ローカルストレージから保存された言語設定を確認
  const savedLocale = localStorage.getItem("hstorage-locale");
  if (savedLocale && supportedLocales.includes(savedLocale)) {
    return savedLocale;
  }

  // ブラウザの言語リストを取得（navigator.languages が優先、フォールバックで navigator.language）
  const browserLanguages = navigator.languages || [navigator.language || "ja"];

  // ブラウザの言語リストをチェックして、サポートしている言語を探す
  for (const browserLang of browserLanguages) {
    // 言語コードを正規化（例: 'en-US' -> 'en'）
    const normalizedLang = browserLang.toLowerCase().split("-")[0];

    // サポートしている言語かチェック
    if (supportedLocales.includes(normalizedLang)) {
      return normalizedLang;
    }
  }

  // サポートしている言語が見つからない場合はデフォルトを返す
  console.log(
    "[i18n] サポートされている言語が見つからないため、デフォルト言語 ja を使用",
  );
  return "ja";
}

const detectedLocale = detectBrowserLanguage();

export const i18n = createI18n({
  legacy: true,
  warnHtmlMessage: false, // not working
  locale: detectedLocale, // ブラウザの言語を自動検出
  fallbackLocale: "en",
  messages,
});

// 言語を動的に変更する関数をエクスポート
export function setLocale(newLocale) {
  if (supportedLocales.includes(newLocale)) {
    i18n.global.locale = newLocale;
    localStorage.setItem("hstorage-locale", newLocale);
  } else {
  }
}

// 現在の言語を取得する関数をエクスポート
export function getCurrentLocale() {
  return i18n.global.locale;
}
